import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const normalizeSkill = (skill) => ({
  id: skill?.id ?? skill?.Id,
  key: skill?.key ?? skill?.Key ?? '',
  title: skill?.title ?? skill?.Title ?? '',
  description: skill?.description ?? skill?.Description ?? '',
  triggers: skill?.triggers ?? skill?.Triggers ?? '',
  bodyMarkdown: skill?.bodyMarkdown ?? skill?.BodyMarkdown ?? '',
  kind: skill?.kind ?? skill?.Kind,
  ownerUserId: skill?.ownerUserId ?? skill?.OwnerUserId ?? null,
  bodyLockedByOwner: Boolean(skill?.bodyLockedByOwner ?? skill?.BodyLockedByOwner),
  isCustom: Boolean(skill?.isCustom ?? skill?.IsCustom)
});

const normalizeSkillList = (payload) => {
  const data = unwrapApiData(payload);
  const list = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : [];
  return list.map(normalizeSkill).filter((skill) => skill.id);
};

export const listProjectSkillsApi = async (projectId) => {
  try {
    const { data } = await apiClient.get(`/projects/${encodeURIComponent(projectId)}/skills`);
    return normalizeSkillList(data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load project skills.'));
  }
};

export const createProjectSkillApi = async (projectId, payload) => {
  try {
    const { data } = await apiClient.post(`/projects/${encodeURIComponent(projectId)}/skills`, payload);
    return normalizeSkill(unwrapApiData(data) ?? data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create project skill.'));
  }
};

export const updateProjectSkillApi = async (projectId, skillId, payload) => {
  try {
    const { data } = await apiClient.put(
      `/projects/${encodeURIComponent(projectId)}/skills/${encodeURIComponent(skillId)}`,
      payload
    );
    return normalizeSkill(unwrapApiData(data) ?? data);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update project skill.'));
  }
};

export const deleteProjectSkillApi = async (projectId, skillId) => {
  try {
    await apiClient.delete(
      `/projects/${encodeURIComponent(projectId)}/skills/${encodeURIComponent(skillId)}`
    );
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete project skill.'));
  }
};
